import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Box,
  useTheme,
  useMediaQuery,
  InputAdornment,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import PageBg from "../../../src/assets/images/auth-bg.png";
import { Link } from "react-router-dom";
import Logo from "../../../src/assets/images/logo.png";
import { useFormik } from "formik";
import * as Yup from "yup";

/** Styles */
import "./set-password.scss";

/** Icons */
import { Visibility, VisibilityOff } from "@material-ui/icons";

const setPasswordSchema = Yup.object({
  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .matches(/[A-Z]/, "Must contain at least one uppercase letter")
    .matches(/[0-9]/, "Must contain at least one number")
    .matches(/[!@#$%^&*]/, "Must contain at least one special character")
    .required("Password is required"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords do not match")
    .required("Please confirm your password"),
});

const SetPasswordPage = (props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  useEffect(() => {
    document.title = "Set Password";
  }, []);

  const formik = useFormik({
    initialValues: {
      password: "",
      confirmPassword: "",
    },
    validationSchema: setPasswordSchema,
    onSubmit: (values) => {
      console.log("Set password data:", values);
    },
  });

  return (
    <div
      className="setpassword-wrapper"
      style={{ backgroundImage: `url(${PageBg})` }}
    >
      <div className="setpassword-overlay" />

      <Container maxWidth="sm" className="setpassword-container">
        <Paper
          elevation={6}
          className={`setpassword-paper ${isMobile ? "mobile" : ""}`}
        >
          <Box className="setpassword-logo">
            <img src={Logo} alt="Logo" className={isMobile ? "mobile" : ""} />
          </Box>

          <Typography align="center" gutterBottom className="setpassword-title">
            Set your password
          </Typography>

          <Typography align="center" className="setpassword-subtitle">
            Create a strong password for your account.
          </Typography>

          <form onSubmit={formik.handleSubmit} className="setpassword-form">
            <Box className={`fields ${isMobile ? "mobile" : ""}`}>
              {/* Password */}
              <TextField
                name="password"
                type={showPassword ? "text" : "password"}
                placeholder="Enter your password"
                fullWidth
                variant="outlined"
                value={formik.values.password}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.password && Boolean(formik.errors.password)
                }
                helperText={formik.touched.password && formik.errors.password}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Button
                        onClick={() => setShowPassword(!showPassword)}
                        edge="end"
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </Button>
                    </InputAdornment>
                  ),
                }}
              />

              {/* Confirm Password */}
              <TextField
                name="confirmPassword"
                type={showConfirmPassword ? "text" : "password"}
                placeholder="Confirm your password"
                fullWidth
                variant="outlined"
                value={formik.values.confirmPassword}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.confirmPassword &&
                  Boolean(formik.errors.confirmPassword)
                }
                helperText={
                  formik.touched.confirmPassword &&
                  formik.errors.confirmPassword
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Button
                        onClick={() =>
                          setShowConfirmPassword(!showConfirmPassword)
                        }
                        edge="end"
                      >
                        {showConfirmPassword ? (
                          <Visibility />
                        ) : (
                          <VisibilityOff />
                        )}
                      </Button>
                    </InputAdornment>
                  ),
                }}
              />

              {/* Password strength hints */}
              <Box className="password-rules">
                <Typography
                  className={`rule ${formik.values.password.length >= 8 ? "valid" : ""}`}
                >
                  ✓ At least 8 characters
                </Typography>
                <Typography
                  className={`rule ${/[A-Z]/.test(formik.values.password) ? "valid" : ""}`}
                >
                  ✓ One uppercase letter
                </Typography>
                <Typography
                  className={`rule ${/[0-9]/.test(formik.values.password) ? "valid" : ""}`}
                >
                  ✓ One number
                </Typography>
                <Typography
                  className={`rule ${/[!@#$%^&*]/.test(formik.values.password) ? "valid" : ""}`}
                >
                  ✓ One special character (!@#$%^&*)
                </Typography>
              </Box>

              <Button
                type="submit"
                variant="contained"
                color="primary"
                size={isMobile ? "medium" : "large"}
                fullWidth
              >
                Set Password
              </Button>
            </Box>
          </form>

          <Typography align="center" className="setpassword-footer">
            <Link to="/login" style={{ color: theme.palette.primary.main }}>
              Back to Login
            </Link>
          </Typography>
        </Paper>
      </Container>
    </div>
  );
};

const mapStateToProps = (state) => ({
  width: state.layout.screenWidth,
});

export default withRouter(connect(mapStateToProps)(SetPasswordPage));
